import clsx from "clsx"
import { memo, useCallback } from "react"
import { useTranslation } from "react-i18next"
import { ArrowLeftIcon } from "@/assets"
import { Button } from "@/ui/Button"
import styles from "./Pagination.module.scss"
import type { IPagination } from "./types"

function PaginationComponent({
  page,
  total,
  perPage,
  onPageChange,
  className,
  ...props
}: IPagination) {
  const { t } = useTranslation()
  const totalPages = Math.ceil(total / perPage)

  const handlePrev = useCallback(() => {
    onPageChange(page - 1)
  }, [onPageChange, page])

  const handleNext = useCallback(() => {
    onPageChange(page + 1)
  }, [onPageChange, page])

  return (
    <div className={clsx(styles.Pagination, className)} {...props}>
      <Button.Ring
        aria-label={t("pagination.prev")}
        onClick={handlePrev}
        className={clsx(styles.Pagination_button, styles.prev)}
        disabled={page <= 1}
      >
        <ArrowLeftIcon />
      </Button.Ring>
      <div className={styles.Pagination_pages}>
        {page} <span>/</span> {totalPages}
      </div>
      <Button.Ring
        aria-label={t("pagination.next")}
        onClick={handleNext}
        className={clsx(styles.Pagination_button, styles.next)}
        disabled={page >= totalPages}
      >
        <ArrowLeftIcon />
      </Button.Ring>
    </div>
  )
}

export const Pagination = memo(PaginationComponent)
